import styled from 'styled-components'

export const DatePickerWrapper = styled.div`
  display: grid;
  gap: 8px;
  width: 220px;
`
